import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { breadCrumb } from './breadcrumb.types';
import { Option } from './Dropdown';

interface State {
	crumbs: breadCrumb;
	dropDownData: Option[];
	bannerText: string;
	bannerCount: number;
	isEnabled: boolean;
	isClientDropDownNeeded: boolean;
	clientDropDownData: Option[];
	selectedClient: string;
	isReportClientDropDownNeeded: boolean;
	reportClientDropDownData: Option[];
	selectedReportClient: string;
	engagementDropDownData : Option[];
	selectedEngagement : string;
	reportEngagementDropDownData : Option[];
	selectedReportEngagement : string;
}

const initialState: State = {
	crumbs: {} as breadCrumb,
	dropDownData: [],
	bannerText: '',
	bannerCount: 0,
	isEnabled: true,
	isClientDropDownNeeded: false,
	clientDropDownData: [],
	selectedClient: '',
	isReportClientDropDownNeeded: false,
	reportClientDropDownData: [],
	selectedReportClient: '',
	engagementDropDownData : [],
	selectedEngagement : '',
	reportEngagementDropDownData : [],
	selectedReportEngagement : ''
};

const breadcrumbSlice = createSlice({
	initialState,
	name: 'breadcrumbs',
	reducers: {
		setCrumbs: (
			state,
			action: PayloadAction<breadCrumb>
		) => {
			if (action.payload) {
				state.crumbs = action.payload;
			}
		},
		setDropDownData: (
			state,
			action: PayloadAction<Option[]>
		) => {
			if (action.payload) {
				state.dropDownData = action.payload;
			}
		},
		setBannerText: (
			state,
			action: PayloadAction<string>
		) => {
			if (action.payload) {
				state.bannerText = action.payload;
			}
		},
		setBannerCount: (
			state,
			action: PayloadAction<number>
		) => {
			if (action.payload >= 0) {
				state.bannerCount = action.payload;
			}
		},
		setClientDropDownNeeded: (
			state,
			action: PayloadAction<boolean>
		) => {
				state.isClientDropDownNeeded = action.payload;
		},
		setClientDropDownData: (
			state,
			action: PayloadAction<Option[]>
		) => {
			if (action.payload) {
				state.clientDropDownData = action.payload;
			}
		},
		setSelectedClient: (
			state,
			action: PayloadAction<string>
		) => {
			if (action.payload) {
				state.selectedClient = action.payload;
			}
		},
		setEngagementDropDownData: (
			state,
			action: PayloadAction<Option[]>
		) => {
			if (action.payload) {
				state.engagementDropDownData = action.payload;
			}
		},
		setSelectedEngagement: (
			state,
			action: PayloadAction<string>
		) => {
			if (action.payload) {
				state.selectedEngagement = action.payload;
			}
		},
		setReportClientDropDownNeeded: (
			state,
			action: PayloadAction<boolean>
		) => {
				state.isReportClientDropDownNeeded = action.payload;
		},
		setReportClientDropDownData: (
			state,
			action: PayloadAction<Option[]>
		) => {
			if (action.payload) {
				state.reportClientDropDownData = action.payload;
			}
		},
		setSelectedReportClient: (
			state,
			action: PayloadAction<string>
		) => {
			if (action.payload) {
				state.selectedReportClient = action.payload;
			}
		},
		setReportEngagementDropDownData: (
			state,
			action: PayloadAction<Option[]>
		) => {
			if (action.payload) {
				state.reportEngagementDropDownData = action.payload;
			}
		},
		setSelectedReportEngagement: (
			state,
			action: PayloadAction<string>
		) => {
			if (action.payload) {
				state.selectedReportEngagement = action.payload;
			}
		},
	}
});

export const {
	setCrumbs,
	setDropDownData,
	setBannerCount,
	setBannerText,
	setClientDropDownNeeded,
	setClientDropDownData,
	setSelectedClient,
	setReportClientDropDownNeeded,
	setReportClientDropDownData,
	setSelectedReportClient,
	setEngagementDropDownData,
	setSelectedEngagement,
	setReportEngagementDropDownData,
	setSelectedReportEngagement
} = breadcrumbSlice.actions;
export default breadcrumbSlice.reducer;